import React, { useRef, useState, useEffect } from "react";
import { Document, Page } from "react-pdf";
import { Skeleton } from "antd";
import PDFCanvasOverlay from "./PDFCanvasOverlay";

export default function PDFViewer({
  pdfUrl,
  pdfId,
  annotations,
  onAddAnnotation,
  currentPage,
  setCurrentPage,
  setNumPages,
  drawMode,
  color
}) {
  const [pageSize, setPageSize] = useState({ width: 1, height: 1 });
  const pageContainerRef = useRef();

  useEffect(() => {
    function updateSize() {
      const node = pageContainerRef.current;
      if (node) {
        setPageSize({
          width: node.offsetWidth,
          height: node.offsetHeight
        });
      }
    }
    updateSize();
    window.addEventListener("resize", updateSize);
    return () => window.removeEventListener("resize", updateSize);
  }, [currentPage]);

  return (
    <div style={{
      position: "relative",
      width: "100%",
      height: "100%",
    }}>
      <div
        ref={pageContainerRef}
        style={{
          width: "fit-content",
          height: "fit-content",
          margin: "0 auto",
          position: "relative"
        }}
      >
        <Document
          file={pdfUrl}
          onLoadSuccess={({ numPages }) => setNumPages(numPages)}
          loading={<Skeleton active paragraph={{ rows: 10 }} style={{ marginTop: 60, width: 600 }} />}
        >
          <Page
            pageNumber={currentPage}
          />
        </Document>
        <PDFCanvasOverlay
          pdfId={pdfId}
          page={currentPage}
          annotations={annotations}
          onAddAnnotation={onAddAnnotation}
          drawMode={drawMode}
          color={color}
          pageWidth={pageSize.width}
          pageHeight={pageSize.height}
        />
      </div>
    </div>
  );
}